import axios from 'axios';
import { useState, useEffect } from 'react';
import { validateContactInputs } from './validation';
import { notify } from '../../../utils/notifications';

export default function useForm() {
    const [inputsErrors, setInputsErrors] = useState({});
    const [onSuccess, setOnSuccess] = useState(null);
    const [onSubmit, setOnSubmit] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);

    const [form, setForm] = useState({
        name: '',
        email: '',
        subject: '',
        countryCode: '',
        phone: '',
        message: '',
        locale: '',
        device: ''
    });

    useEffect(() => {
        setForm((form) => ({
            ...form,
            device: navigator.userAgent,
            locale: navigator.language.toLowerCase()
        }));
    }, [onSubmit]);

    useEffect(() => {
        if (Object.keys(form).some((field) => !form[field])) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [form]);

    const handleChange = async (event) => {
        const data = event.target ? event.target : event;
        const { name, value } = data;
        if (value === 'Select an option') {
            setForm({ ...form, [name]: '' });
        } else {
            setForm({ ...form, [name]: value });
        }
    };

    const handleChangePhone = async (event) => {
        const data = event.target ? event.target : event;
        const { name, value } = data;
        let phone;
        if (value.charAt(0) === '0') {
            phone = form.phone.slice(1);
        }
        setForm({ ...form, [name]: phone ? phone : value });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await axios.post(`/api/zendesk/create`, form);
            setOnSuccess(response?.data?.ticket?.id);
            notify('success', 'Success!');
        } catch (error) {
            const { message } = error.response.data;
            if (message) {
                notify('error', `Error: ${message}`);
            } else {
                notify(
                    'error',
                    'Error: Oops! Something went wrong on our side. Please try again later.'
                );
            }
        }
    };

    const handleButton = async (event) => {
        event.preventDefault();
        setOnSubmit(true);
        if (validateContactInputs(form, inputsErrors, setInputsErrors)) {
            setInputsErrors({});
            handleSubmit(event).then();
        }
    };

    return {
        handleChange,
        handleChangePhone,
        handleButton,
        isDisabled,
        inputsErrors,
        onSuccess,
        form
    };
}
